import { render, staticRenderFns } from "./VariantPickerModal.vue?vue&type=template&id=f5b1e9bc"
import script from "./VariantPickerModal.vue?vue&type=script&lang=js"
export * from "./VariantPickerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports